import { StatusInterface } from "./StatusInterface";

import { Verified } from "./Statuses/Verified";
import { NotVerified } from "./Statuses/NotVerified";
import { Failed } from "./Statuses/Failed";

class StatusContainer {

  private statuses = [
    Verified,
    NotVerified,
    Failed
  ];

  private instances = [
    new Verified(),
    new NotVerified(),
    new Failed()
  ];

  public getStatuses() {
    return this.statuses;
  }

  public getInstances() {
    return this.instances;
  }

  public pickFromId(statusId: number): StatusInterface {
    const index = this.getInstances().findIndex(status => status.getValue() === statusId);
    return this.getInstances()[index];
  }

}

export default new StatusContainer();
